import { render, staticRenderFns } from "./UserRoleChips.vue?vue&type=template&id=62e4fbba"
import script from "./UserRoleChips.vue?vue&type=script&lang=js"
export * from "./UserRoleChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports